import React, { useState } from 'react';
import './assets/styles/index.scss';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import { AuthenticatedRoutesWrapper, DappProvider } from '@multiversx/sdk-dapp/wrappers';
import { environment, projectId, supportedChains, web3modalMetadata } from './config';
import { SignTransactionsModals, TransactionsToastList } from '@multiversx/sdk-dapp/UI';
import Home from './pages/Home';
import Rewards from './pages/Rewards';
import ConnectWallet from './pages/ConnectWallet';

import { WagmiConfig, configureChains, createConfig } from 'wagmi';
import { createWeb3Modal } from '@web3modal/wagmi/react';
import { walletConnectProvider } from '@web3modal/wagmi';

function App() {
    const [forceReload, setForceReload] = useState(null);

    const { chains } = configureChains(
        supportedChains,
        [walletConnectProvider({ projectId })]
    );

    const wagmiConfig = createConfig({
        autoConnect: true,
        projectId,
        chains,
        metadata: web3modalMetadata,
    });

    createWeb3Modal({
        wagmiConfig,
        projectId,
        chains,
        termsConditionsUrl: null,
        themeVariables: {
            '--w3m-font-family': 'PlusJakartaSans',
            '--w3m-accent': 'hsl(285, 100%, 58%)',
            '--w3m-border-radius-master': '2px',
            '--w3m-color-mix-strength': '50',
            '--w3m-color-mix': 'hsl(240, 15%, 13%)',
        },
    });

    const routes = [
        {
            path: '/',
            element: <Home />,
            authenticatedRoute: false,
        },
        {
            path: '/connect-wallet',
            element: <ConnectWallet />,
            authenticatedRoute: false,
        },
        {
            path: '/rewards',
            element: <Rewards key={forceReload} />,
            authenticatedRoute: true,
        },
    ];

    return (
        <WagmiConfig config={wagmiConfig}>
            <DappProvider
                environment={environment}
                customNetworkConfig={{ 
                    walletConnectV2ProjectId: projectId,
                    chainId: chains[0]?.id // Add chainId from supported chains
                }}
                dappConfig={{
                    shouldUseWebViewProvider: true,
                }}
                customComponents={{
                    transactionTracker: {
                        props: {
                            onSuccess: (sessionId) => {
                                setForceReload(sessionId);
                            },
                        },
                    },
                }}
            >
                <Router>
                    <SignTransactionsModals />
                    <TransactionsToastList successfulToastLifetime={2500} />
                    <Navbar />
                    <AuthenticatedRoutesWrapper routes={routes} unlockRoute="/connect-wallet">
                        <Routes>
                            {routes.map((route, index) => (
                                <Route key={index} path={route.path} element={route.element} />
                            ))}
                        </Routes>
                    </AuthenticatedRoutesWrapper>
                </Router>
            </DappProvider>
        </WagmiConfig>
    );
}

export default App;
